
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import { Field, DropdownField } from '@samc/centricity-core';
  import { BidTypeSource } from '@/Sources';

  @Component({
    name: 'bid-type-dropdown-field',
    components: { Field, DropdownField }
  })
  export default class BidTypeDropdownField extends Vue {
    @Prop() public value!: number;
    @Prop({ default: 'Bid Type' }) public label!: string;
    @Prop({ default: '' }) public errorText!: string;
    @Prop({ type: Boolean, default: false }) public disabled!: boolean;
    @Prop({ type: Boolean, default: false }) public autoAssign!: boolean;
    @Prop() public placeholder!: string;

    public source: BidTypeSource = new BidTypeSource();

    public get val(): number { return this.value; }
    public set val(value: number) {

      this.$emit('input', value);
    }
  }
